import React, { useEffect } from "react";
import "../../styles/booking-form.css";
import { Form, FormGroup, Container } from "reactstrap";

import AOS from "aos";
import "aos/dist/aos.css";

const BookingForm = () => {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  const submitHandler = (event) => {
    event.preventDefault();
  };
  return (
    <Container className="container">
      <form>
        <div class="form-row">
          <div class="input-data">
            <input type="text" name="name" required  />
            <div class="underline"></div>
            <label for="">Name</label>
          </div>
          <div class="input-data">
            <input type="email" name="email" required />
            <div class="underline"></div>
            <label for="">Email</label>
          </div>
        </div>
        <div class="form-row">
          <div class="input-data">
            <input type="text" name="fromAddress" required />
            <div class="underline"></div>
            <label for="">From Address</label>
          </div>
          <div class="input-data">
            <input type="text" name="toAddress" required />
            <div class="underline"></div>
            <label for="">To Address</label>
          </div>
        </div>
        <div class="form-row">
          <div class="input-data">
            <input type="time" name="time" required />
            <div class="underline"></div>
            <label for="" className="time">Travel Time</label>
          </div>
          <div class="input-data">
            <input type="date" name="date" required />
            <div class="underline"></div>
            <label for="" className="date">Travel Date</label>
          </div>
        </div>
        <div class="form-row">
          <div class="input-data textarea">
            <div class="form-row submit-btn">
              <div class="input-data">
                <div class="inner"></div>
                <input type="submit" value="Request" />
              </div>
            </div>
          </div>
        </div>
      </form>
    </Container>
  );
};

export default BookingForm;
